import React from 'react';
import { matchPath, useHistory, useLocation } from 'react-router-dom';
import routes from '../../../utils/commonVariables/routes';
import { useZitoneoUI } from '../contexts/ZitoneoUIContext';
import { useZitoneoServices } from '../contexts/ZitoneoContentContext';
import { ZitoneoViewMode } from '../types/zitoneoServicesTypes';
import { zitoneoRouteDefinitions, zitoneoRoutes } from '../utils/zitoneoRoutes';
import HeaderBrand from '../hotelContent/detail/header/HeaderBrand';
import HeaderHotelNavigation from '../hotelContent/detail/header/HeaderHotelNavigation';
import HeaderEditorControls from '../hotelContent/detail/header/HeaderEditorControls';
import HeaderActions from '../hotelContent/detail/header/HeaderActions';
import '../stylesheets/zitoneo-header.scss';

const ZitoneoHeader = () => {
    const history = useHistory();
    const { pathname } = useLocation();
    const { viewMode, isLoading } = useZitoneoUI();
    const { hasUnsavedChanges, saveHotelContent } = useZitoneoServices();
    const isInDetail = Boolean(
        matchPath(pathname, { path: zitoneoRouteDefinitions.HOTEL_CONTENT })
    );
    const isHotelPresentation = Boolean(
        matchPath(pathname, {
            path: zitoneoRouteDefinitions.HOTEL_PRESENTATION,
            exact: true,
        })
    );
    const isEditor = isInDetail && viewMode === ZitoneoViewMode.EDITOR;
    const isPreview = isInDetail && viewMode === ZitoneoViewMode.PREVIEW;
    const isSettings = isInDetail && viewMode === ZitoneoViewMode.SETTINGS;
    const navigationProps = {
        isLoading,
        hasUnsavedChanges,
        onSave: async () => {
            await saveHotelContent();
        },
        onBackToList: () => {
            if (!isLoading) {
                history.push(zitoneoRoutes.HOTELS_CONTENT_LIST);
            }
        },
    };

    return (
        <header className={`zitoneo__header ${isLoading ? '--loading' : ''}`}>
            <div className='zitoneo-header__main'>
                <HeaderBrand
                    {...navigationProps}
                    onBackToHome={() => {
                        if (!isLoading) {
                            history.push(routes.landingPrivate);
                        }
                    }}
                />
                {(isInDetail || isHotelPresentation) && (
                    <div className='zitoneo-header__context zitoneo-header__inert'>
                        <HeaderHotelNavigation
                            {...navigationProps}
                            isHotelPresentation={isHotelPresentation}
                        />
                        {isEditor && <HeaderEditorControls />}
                    </div>
                )}
            </div>
            <HeaderActions
                isInDetail={isInDetail}
                isHotelPresentation={isHotelPresentation}
                isEditor={isEditor}
                isPreview={isPreview}
                isSettings={isSettings}
            />
        </header>
    );
};

export default ZitoneoHeader;
